import { getUserDiagnoticsStateColor } from 'utilities/SystemUtils';
import AppChip from './AppChip';
import { UserDiagnosticsState } from 'types/models/UserDiagnosticsModel';

export const AppUserDiagnosticsStateChip = ({ userDiagnosticsState }: {userDiagnosticsState: UserDiagnosticsState}) => {
  const displayValue = UserDiagnosticsState[userDiagnosticsState];

  return (
    <AppChip
      value={userDiagnosticsState}
      getColor={getUserDiagnoticsStateColor}
      displayValue={displayValue}
    />
  );
};

export default AppUserDiagnosticsStateChip;
